import {AfterViewInit, Directive, Host, Input, OnDestroy} from '@angular/core';
import {first} from 'rxjs/operators';
import {ExgMapComponent, ExgMapDrawingManagerDirective} from '../directives';

@Directive({
  selector: 'exg-map[exgMapDrawingManager]',
  exportAs: 'matDrawingManagerTrigger',
})
export class ExgMapDrawingManagerTriggerDirective implements AfterViewInit, OnDestroy {

  /** The drawing manager to be attached to this trigger. */
    // tslint:disable-next-line: no-input-rename
  @Input('exgMapDrawingManager') drawingManager!: ExgMapDrawingManagerDirective;

  constructor(@Host() private _exgMap: ExgMapComponent) {
  }

  ngAfterViewInit(): void {
    this._exgMap.mapReady.pipe(first()).subscribe(map => this.drawingManager.setMap(map));
  }

  ngOnDestroy(): void {
    this._exgMap.mapReady.pipe(first()).subscribe(() => this.drawingManager.setMap(null as any));
  }
}
